import React from 'react'

export interface Option {
  label: string
  value: string
  disabled?: boolean
  hidden?: boolean
}

export interface SelectInputProps {
  label: string
  value: string
  options: Option[]
  onChange: (value: string) => void
  name: string
  disabled?: boolean
  className?: string
  borderClassName?: string
  error?: string
}
function SelectInput({
  name,
  label,
  value,
  options,
  onChange,
  disabled,
  className = '',
  borderClassName = '',
  error,
}: SelectInputProps) {
  const handleChange = React.useCallback<
    React.ChangeEventHandler<HTMLSelectElement>
  >(
    (event) => {
      onChange(event.target.value)
    },
    [onChange]
  )

  return (
    <div
      className={`flex flex-col rounded-lg p-2 text-default ${className} ${borderClassName || 'border'}`}
    >
      {error && <small className="text-left text-red-500">{error}</small>}

      <div className="flex items-center text-fontBlackColour">
        <label htmlFor={name}>{label}</label>
        <select
          id={name}
          value={value}
          disabled={disabled}
          onChange={handleChange}
          className={`w-full border-none text-default focus:border-[#D9D9D9] focus:ring-0 ${
            disabled ? 'pointer-events-none cursor-not-allowed' : ''
          }`}
        >
          {options.map((option) => (
            <option
              key={option.value}
              value={option.value}
              hidden={option.hidden}
              disabled={option.disabled}
            >
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}

export default SelectInput
